import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { PublicStore } from "@/lib/store/public";
import { ref } from "vue";
import BulmaButton from "@/bulma/Button.vue";
import LoginModal from "./LoginModal.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginButton',
    setup(__props) {
        const store = PublicStore();
        const modal_visible = ref(false);
        const is_busy = ref(false);
        function on_click() {
            if (store.user !== null) {
                store.logout();
            }
            else {
                // show login modal
                is_busy.value = true;
                modal_visible.value = true;
            }
        }
        function modal_submit(creds) {
            modal_visible.value = false;
            store.login(creds).finally(() => (is_busy.value = false));
        }
        function modal_cancel() {
            modal_visible.value = false;
            is_busy.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (modal_visible.value)
                    ? (_openBlock(), _createBlock(LoginModal, {
                        key: 0,
                        onSubmit: modal_submit,
                        onCancel: modal_cancel
                    }))
                    : _createCommentVNode("", true),
                _createVNode(BulmaButton, _mergeProps(_ctx.$attrs, {
                    busy: is_busy.value,
                    icon: ['fas', _unref(store).user !== null ? 'toggle-on' : 'toggle-off'],
                    text: _unref(store).user !== null ? _unref(store).user.mail : 'Login',
                    onClick: _withModifiers(on_click, ["left"])
                }), null, 16, ["busy", "icon", "text"])
            ], 64));
        };
    }
});
